/* eslint no-fallthrough: 0 */

/* eslint default-case: 0 */
import { exists } from 'js/lib/utility/exists';
import { options } from 'js/features/apply_chosen';

function hasSelectedTrxTypeWithRecurringType() {
  var TRANSACTION_TYPES_WITH_RECURRING_TYPE = ['authorize', 'authorize3d', 'sale', 'sale3d'];

  for (var _i = 0, _TRANSACTION_TYPES_WI = TRANSACTION_TYPES_WITH_RECURRING_TYPE; _i < _TRANSACTION_TYPES_WI.length; _i++) {
    var transaction_type = _TRANSACTION_TYPES_WI[_i];

    if ($('#pay_by_link_transaction_type_' + transaction_type).prop('checked')) {
      return true;
    }
  }

  return false;
}

function updateRecurringTypeFields() {
  var isTransactionWithRecurringTypeInRequest = hasSelectedTrxTypeWithRecurringType();

  if (isTransactionWithRecurringTypeInRequest) {
    $('#recurring_type').removeClass('hidden');
    $('#pay_by_link_recurring_type').addClass('for_chosen').chosen(options);
  } else {
    $('#recurring_type').addClass('hidden');
  }
}

function listenForTransactionTypeChange() {
  var transactionTypesContainer = '.transaction-types-container';

  if (exists($(transactionTypesContainer))) {
    updateRecurringTypeFields();
    $(transactionTypesContainer).on('change', function () {
      updateRecurringTypeFields();
    });
  }
}

var PayByLinkRecurringType = {
  updateFields: updateRecurringTypeFields,
  listenForChange: listenForTransactionTypeChange
};
export default PayByLinkRecurringType;